import { profileListApi } from "../../api/profile/profileListApi"
import { Profile } from "../../entities/profile"

type PayloadShape = Parameters<typeof profileListApi>[0]

export async function profileListService(payload: PayloadShape, token?: null | string) {
	const profile = await profileListApi(payload, token)
	return profile as NonNullable<Profile[]>
}
